export default __webpack_public_path__ + "static/three-hands-02ab8bb024e909813fcf3115fad1239c.svg";